/**
 * Centralized runtime application config.
 *
 * Values are injected by Laravel at request time via
 * resources/views/layouts/partials/common/app-config.blade.php
 * (window.__APP_CONFIG__), mapped from their real config sources
 * (config/app.php, config/broadcasting.php, config/filesystems.php).
 *
 * This replaces the former build-time import.meta.env.VITE_* variables so
 * a single Vite build artifact works across all deployment scenarios.
 * Do NOT read import.meta.env.VITE_* anywhere in the app.
 */

export interface AppConfig {
    appName: string;
    appUrl: string;
    broadcastDriver: string | null;
    reverbAppKey: string | null;
    reverbHost: string | null;
    reverbPort: string | number;
    reverbScheme: string;
    reverbAppCluster: string;
    awsUrl: string | null;
}

declare global {
    interface Window {
        __APP_CONFIG__?: Partial<AppConfig>;
    }
}

const defaults: AppConfig = {
    appName: '',
    appUrl: '',
    broadcastDriver: null,
    reverbAppKey: null,
    reverbHost: null,
    reverbPort: 6001,
    reverbScheme: 'http',
    reverbAppCluster: 'mt1',
    awsUrl: null,
};

const runtime: Partial<AppConfig> =
    (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};

if (typeof window !== 'undefined' && !window.__APP_CONFIG__) {
    console.warn(
        '[appConfig] window.__APP_CONFIG__ is missing — is the app-config Blade partial included in the layout?'
    );
}

export const appConfig: AppConfig = { ...defaults, ...runtime };

export default appConfig;
